import React from 'react';
import { useProductVariants } from '../../hooks/useProductVariants';
import { useShopConfig } from '@jetshop/core/hooks/useShopConfig';
import ChannelContext from '@jetshop/core/components/ChannelContext';
import { Helmet } from 'react-helmet-async';
/**
 * Get the brand field from a product's customFields.
 *
 * Usually you'd want to pass in the brand field from your shop config.
 */
export function getBrand(product, brandField = 'brand') {
    var _a;
    const field = (_a = product === null || product === void 0 ? void 0 : product.customFields) === null || _a === void 0 ? void 0 : _a.find(({ key }) => key === brandField);
    if (field) {
        return field === null || field === void 0 ? void 0 : field.stringValue;
    }
}
export const OpenGraphProductData = ({ product, initialVariant, optionalFields = [] }) => {
    var _a, _b, _c, _d;
    const { selectedVariant: variant } = useProductVariants(product, {
        initialVariant
    });
    const { selectedChannel } = React.useContext(ChannelContext);
    const { brandCustomField } = useShopConfig();
    const prod = variant || product;
    const brand = getBrand(product, brandCustomField);
    const overrides = optionalFields.map((tag) => tag.property);
    // If these are updated, please also update the docs (OpenGraph.mdx)
    const defaultTags = [
        {
            property: 'product:original_price:amount',
            content: (_a = prod.previousPrice) === null || _a === void 0 ? void 0 : _a.incVat
        },
        { property: 'product:price:amount', content: (_b = prod.price) === null || _b === void 0 ? void 0 : _b.incVat },
        {
            property: 'og:price:currency',
            content: selectedChannel.currency.format.code
        },
        { property: 'product:availability', content: (_c = prod.stockStatus) === null || _c === void 0 ? void 0 : _c.buyable },
        { property: 'product:brand', content: brand },
        { property: 'product:category', content: (_d = product.canonicalCategory) === null || _d === void 0 ? void 0 : _d.name }
    ].filter((tag) => !overrides.includes(tag.property));
    return (React.createElement(Helmet, null,
        defaultTags.map((tag) => {
            return (tag.content && (React.createElement("meta", { key: `og-tag-${tag.property}`, property: tag.property, content: tag.content })));
        }),
        optionalFields.map((tag) => (React.createElement("meta", { key: `og-tag-${tag.property}`, property: tag.property, content: tag.content })))));
};
//# sourceMappingURL=OpenGraphProductData.js.map